
function percentageFilter ($filter) {
	return function(input, decimals) {
		return $filter('number')(input * 100, decimals) + '%';
	};
}

percentageFilter.$inject = ['$filter'];

export default angular.module('filter.percentageFilter', [])
	.filter('percentageFilter', percentageFilter)
	.name;



// WEBPACK FOOTER //
// ./src/filter/percentage.js